import React, { useEffect, useRef, useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Overlaytext from "../components/Overlaytext/Overlaytext";
import ImageReveal from "../components/ImageReveal";

const AboutPage = () => {
  const [counters, setCounters] = useState({
    clients: 0,
    success: 0,
    experience: 0,
    revenue: 0
  });

  const [isVisible, setIsVisible] = useState(false);
  const statsRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !isVisible) {
          setIsVisible(true);
          animateCounters();
        }
      },
      { threshold: 0.3 }
    );

    if (statsRef.current) {
      observer.observe(statsRef.current);
    }

    return () => observer.disconnect();
  }, [isVisible]);

  const animateCounters = () => {
    const targets = {
      clients: 500,
      success: 95,
      experience: 10,
      revenue: 50
    };

    const duration = 2000; // 2 seconds
    const steps = 60; // 60 steps for smooth animation
    const stepDuration = duration / steps;

    let currentStep = 0;

    const timer = setInterval(() => {
      currentStep++;
      const progress = currentStep / steps;

      // Easing function for smooth animation
      const easeOutQuart = 1 - Math.pow(1 - progress, 4);

      setCounters({
        clients: Math.floor(targets.clients * easeOutQuart),
        success: Math.floor(targets.success * easeOutQuart),
        experience: Math.floor(targets.experience * easeOutQuart),
        revenue: Math.floor(targets.revenue * easeOutQuart)
      });

      if (currentStep >= steps) {
        clearInterval(timer);
        // Ensure final values are exact
        setCounters({
          clients: targets.clients,
          success: targets.success,
          experience: targets.experience,
          revenue: targets.revenue
        });
      }
    }, stepDuration);
  };
  return (
    <div className="App">
      <Header />

      {/* Hero Section */}
      <Overlaytext title="About Us" subtitle="We are a leading industrial solutions provider dedicated to helping businesses achieve their growth objectives." backgroundImage=" https://images.unsplash.com/photo-1758873268877-3cd8ed329ed8?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&q=80&w=3132 " />

      {/* Main About Content */}
      <section className="about-main">
        <div className="container">
          <div className="about-content">
            <div className="about-text">
              <h2>Our Story</h2>
              <p>
                Founded with a vision to revolutionize sales consulting, HEM
                SALES AGENCIES has grown from a small startup to a leading force
                in the industry. Our journey began with a simple belief: every
                business deserves access to world-class sales strategies and
                expertise.
              </p>
              <p>
                Over the years, we've helped hundreds of companies transform
                their sales performance, from startups looking to establish
                their first sales processes to established enterprises seeking
                to optimize their existing operations.
              </p>

              <h3>Our Mission</h3>
              <p>
                To empower businesses with innovative sales solutions that drive
                sustainable growth and measurable results. We believe in
                building long-term partnerships with our clients, providing
                ongoing support and expertise that evolves with their needs.
              </p>

              <h3>Our Values</h3>
              <ul className="values-list">
                <li>
                  <strong>Excellence:</strong> We strive for the highest
                  standards in everything we do
                </li>
                <li>
                  <strong>Innovation:</strong> We embrace new technologies and
                  methodologies
                </li>
                <li>
                  <strong>Integrity:</strong> We maintain transparency and
                  honesty in all our relationships
                </li>
                <li>
                  <strong>Results:</strong> We focus on delivering measurable
                  outcomes for our clients
                </li>
              </ul>
            </div>

            <div className="about-image">
              <ImageReveal 
                src="/Images/AboutUsImage.jpeg" 
                alt="HEM SALES AGENCIES"
                objectFit="cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="stats-section" ref={statsRef}>
        <div className="container">
          <h2>Our Impact</h2>
          <div className="stats-grid">
            <div className="stat-item">
              <h3 className="counter">{counters.clients}+</h3>
              <p>Clients Served</p>
            </div>
            <div className="stat-item">
              <h3 className="counter">{counters.success}%</h3>
              <p>Success Rate</p>
            </div>
            <div className="stat-item">
              <h3 className="counter">{counters.experience}+</h3>
              <p>Years Experience</p>
            </div>
            <div className="stat-item">
              <h3 className="counter">${counters.revenue}M+</h3>
              <p>Revenue Generated</p>
            </div>
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="team-section">
        <div className="container">
          <h2>Meet Our Team</h2>
          <div className="team-grid">
            <div className="team-member">
              <div className="member-avatar">👨‍💼</div>
              <h3>John Smith</h3>
              <p>CEO & Founder</p>
              <p>15+ years in sales leadership</p>
            </div>
            <div className="team-member">
              <div className="member-avatar">👩‍💼</div>
              <h3>Sarah Johnson</h3>
              <p>Head of Sales Strategy</p>
              <p>Expert in B2B sales optimization</p>
            </div>
            <div className="team-member">
              <div className="member-avatar">👨‍💻</div>
              <h3>Mike Chen</h3>
              <p>Sales Analytics Director</p>
              <p>Data-driven sales insights specialist</p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AboutPage;
